export default "__VITE_PUBLIC_ASSET__3c39a088__"